import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * DELETE `/mom/work-order/{workOrderId}/stock-issue/{stockIssueId}`（僅 DRAFT）。
 *
 * @param {string} workOrderId
 * @param {string} stockIssueId
 */
export async function cancelWorkOrderStockIssue(workOrderId, stockIssueId) {
  const { data: raw } = await request.delete(
    `/mom/work-order/${workOrderId}/stock-issue/${stockIssueId}`,
  );
  return parseVer4DetailResponse(raw);
}
